import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  hubTenants: []
};

const store = {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};

export default store;
